import { Box, useMediaQuery } from "@mui/material";
import { colors, fontFamilies } from "~/theme";

interface ArtworkMintDateProps {
    createdAt?: string;
}

export function ArtworkMintDate({ createdAt }: ArtworkMintDateProps) {
    const isDesktop = useMediaQuery("(min-width:1100px)");

    if (createdAt) {
        const formatter = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            day: "numeric",
            month: "long",
        });
        const mintDate = new Date(createdAt);
        const date = formatter.format(mintDate).replace(",", " ");

        return (
            <Box
                fontFamily={fontFamilies.poppins}
                fontStyle="normal"
                fontSize={!isDesktop ? "13px" : "16px"}
                fontWeight={400}
                color={colors.bodyGrey}
                marginTop={!isDesktop ? "8px" : "16px"}
                data-testid="minted-on-date"
            >
                Minted on {date}
            </Box>
        );
    }

    return null;
}
